module.exports = __webpack_public_path__ + "3617f12a08f21a02ff175b584b84b601.svg";